<m-device class="cell" *ngFor="let device of devices" [device]="device" [isGhost]="loadingDevices"></m-device>
